import React, { useCallback, useEffect, useRef, useState } from "react";
import "../assets/style.css";
import "../assets/main.css";
import "../assets/Tailwind.css";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import Paper from "@material-ui/core/Paper";

import Button from "@material-ui/core/Button";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { Grid } from "@material-ui/core";
import { text, textConfianza, textProyect } from "./helpers/textHelpers";
import MenuIcon from "@material-ui/icons/Menu";
import PhoneIcon from "@material-ui/icons/Phone";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EmailIcon from "@material-ui/icons/Email";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { PaginaForm } from "./PaginaForm";
import { Carrousel } from "./Carrousel";
import "animate.css";
import {
  Services,
  ServicesResponsibo,
  TextConfianza,
  TextConfianzaResponsibo,
  TextProyect,
} from "./Services";
import { ServicesResponsive } from "./ServicesResponsive";
import { handleTime } from "./helpers/time";

export default function PaginaPrincipal() {
  const [first, setfirst] = useState("");
  let classNameFeatures = "className";
  let classNameActived = "classNameActived";
  let classDisplayNone = "classDisplayNone";
  let classNameH6 = "classNameH6";
  let classNameH7 = "classNameH7";
  let clasNameFeature = "clasNameFeature";
  let classNameOrigin = "classNameOrigin";
  let classNameOriginLeft = "classNameOriginLeft";
  let clase = "clase";
  let claseOut = "claseOut";
  const refServices = useRef(null);
  const refAbout = useRef(null);
  const scrollToServices = () =>
    refServices.current.scrollIntoView({ behavior: "smooth" });
  const scrollAbout = () =>
    refAbout.current.scrollIntoView({ behavior: "smooth" });
  const [showMore, setShowMore] = useState(false);
  const [showMoreProyects, setShowMoreProyects] = useState(false);
  const [showMoreClientes, setShowMoreClientes] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [closeMenu, setCloseMenu] = useState(true);
  const [handlePlay, setHandlePlay] = useState(false);

  const [clasess, setClasess] = useState(clase);
  const [clasNameFeature1, setClasNameFeature1] = useState();
  const [clases, setClases] = useState();
  const [clasesFeature2, setClasesFeature2] = useState();
  const [clasesFeature3, setClasesFeature3] = useState();
  const [classNameSecond, setClassNameSecond] = useState();

  const handleButton = (option) => {
    if (option === "showMore") {
      setShowMore(!showMore);
    } else if (option === "showMoreProyecs") {
      setShowMoreProyects(!showMoreProyects);
    } else if (option === "showMoreClientes") {
      setShowMoreClientes(!showMoreClientes);
    }
  };

  const handleOpenMenu = () => {
    setOpenMenu(true);
    setCloseMenu(false);
  };
  const handleCloseMenu = () => {
    setCloseMenu(true);
    setOpenMenu(false);
  };

  const handleWhattsapp = () => {
    const wspNumber = "3834367101";
    const mensaje = "¡Hola! Me gustaría obtener más información sobre sus servicios.";
    const mensajeCodificado = encodeURIComponent(mensaje);
    const url = `https://api.whatsapp.com/send?phone=${wspNumber}&text=${mensajeCodificado}`;
    window.open(url);
  };

  useEffect(() => {
    handleTime(setfirst);
    if (
      showMore === false &&
      showMoreProyects === false &&
      showMoreClientes === false
    ) {
      setClases(classNameOriginLeft);
      setClasesFeature2(classNameOrigin);
      setClasesFeature3(classNameOrigin);
      setClassNameSecond(classNameH6);
      setClasNameFeature1(clasNameFeature);
    } else if (showMore && !showMoreProyects && !showMoreClientes) {
      setClasesFeature2(classDisplayNone);
      setClasesFeature3(classDisplayNone);
      setClases(classNameActived);
      setClassNameSecond(classNameH7);
      setClasNameFeature1(classNameFeatures);
    } else if (showMoreProyects && !showMore && !showMoreClientes) {
      setClases(classDisplayNone);
      setClasesFeature3(classDisplayNone);
      setClasesFeature2(classNameActived);
      setClassNameSecond(classNameH7);
      setClasNameFeature1(classNameFeatures);
    } else if (showMoreClientes && !showMore && !showMoreProyects) {
      setClases(classDisplayNone);
      setClasesFeature2(classDisplayNone);
      setClasesFeature3(classNameActived);
      setClassNameSecond(classNameH7);
      setClasNameFeature1(classNameFeatures);
    }
  }, [handleButton]);
  /* 
  if (first.toString() === "06/30/2022") {
    setClasess(claseOut);
  } */

  return (
    <body>
      <div className="md:hidden responsive">
        <img
          src={"/LOGO_VIVERO_LOS_AROMOS.svg"}
          className="img-responsive"
          alt="logo"
        />
        <div
          className="cursor-pointer"
          hidden={openMenu}
          onClick={handleOpenMenu}
        >
          <MenuIcon
            style={{
              position: "absolute",
              right: "0px",
              height: "3.5rem",
              width: "6rem",
              top: "31px",
            }}
          />
        </div>

        <div className="nave" hidden={closeMenu}>
          <ul className="grid grid-cols-1 ">
            <Link style={{ textDecoration: "none", color: "white" }} to="/">
              <li className="text-left block p-4 border-b-2 border-indigo-100 cursor-pointer">
                inicio
              </li>
            </Link>
            <a
              className="cursor-pointer"
              style={{ color: "white" }}
              onClick={scrollToServices}
            >
              <li className="text-left block p-4 border-b-2 border-indigo-100 cursor-pointer">
                Divisiónes
              </li>
            </a>
            <a
              className="cursor-pointer"
              style={{ color: "white" }}
              onClick={scrollToServices}
            >
              <li className="text-left block p-4 border-b-2 border-indigo-100 cursor-pointer">
                Responsabilidad ambiental
              </li>
            </a>
            <li className="text-left no-underline block text-white p-4 border-b-2 border-indigo-100 cursor-pointer">
              <Link
                style={{ textDecoration: "none", color: "white" }}
                onClick={handleWhattsapp}
              >
                {" "}
                Contacto{" "}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="page" onClick={handleCloseMenu}>
        <div className="hidden sm:flex">
          <WhatsAppIcon
            onClick={handleWhattsapp}
            className="bg-green-500 text-white"
            style={{
              cursor: "pointer",
              fontSize: "60px",
              position: "fixed",
              zIndex: "40",
              right: "25px",
              bottom: "44px",
              borderRadius: "50%",
            }}
          />
        </div>
        {/* 
//Navegacion destock */}
        <div className="sm:flex hidden page-header">
          <img
            src={"/LOGO_VIVERO_LOS_AROMOS.svg"}
            className="h-32 w-52"
            alt="logo"
          />
          {/* <h2></h2> */}
          <ul>
            <li>
              <Link style={{ textDecoration: "none", color: "white" }} to="/">
                {" "}
                Inicio{" "}
              </Link>
            </li>
            <li>
              <a
                className="cursor-pointer"
                style={{ color: "white" }}
                onClick={scrollToServices}
              >
                Divisiónes
              </a>
            </li>
            <li>
              <a
                className="cursor-pointer"
                style={{ color: "white" }}
                onClick={scrollToServices}
              >
                Responsabilidad ambiental
              </a>
            </li>
            <li>
              <Link
                style={{ textDecoration: "none", color: "white" }}
                onClick={handleWhattsapp}
              >
                {" "}
                Contacto{" "}
              </Link>
            </li>
          </ul>
        </div>
        <div className="relative z-10 hidden sm:flex">
          <Carrousel></Carrousel>
        </div>
        <div className="mb-10 relative z-10 sm:hidden flex">
          <ServicesResponsive></ServicesResponsive>
        </div>

        <div className="subject">
          <h1 ref={refServices} style={{ color: "#2c4c21", fontWeight: 'bold' }}>
            LOS AROMOS S.A
          </h1>
          <p style={{ width: '90%', margin: 'auto', paddingTop: '10px' }}>
            Desde hace 30 años, Los Aromos S.A. es un vivero industrial, referenciado y respetado por la producción en el sector olivícola agroindustrial, además de otras especies, enfocado en la excelencia de las plantas que produce.
            La genética de nuestras plantas se ha resguardado a través de la selección de material de nuestro propio jardín varietal, sumado a un esfuerzo permanente en capacitación y evolución tecnológica. Podemos decir con orgullo que nuestras plantas se encuentran hoy entre las más reconocidas del mercado nacional.
            La producción de plantas se realiza bajo cubierta en invernaderos y en ambiente controlado de agua, luz y temperatura, implementando programas preventivos en todos los estadios de desarrollo para garantizar la sanidad de las mismas.
          </p>
        </div>
        <div className="subject" style={{ paddingTop: "1px" }}>
          <img
            src="/LOGO_VIVERO_LOS_AROMOS.svg"
            style={{ width: "9rem", margin: 'auto' }}
          />{" "}
        </div>

        {/* 
  responsivo===============
 */}
        {
          <div
            className={"md:hidden content-center text-center justify-center"}
          >
            <div className={"feature-1 mt-5"}>
              <h2 className="font-bold text-xl mb-2 mt-5">Divisiónes</h2>
              <p className="">
                <h6 className={"classResponsive"}>
                  {showMore ? (
                    <ServicesResponsibo></ServicesResponsibo>
                  ) : (
                    text.substring(0, 150)
                  )}
                </h6>
                <Button
                  variant="contained"
                  style={{
                    marginLeft: "10px",
                    padding: "7px",
                    width: "7rem",
                    height: "2rem",
                    backgroundColor: "#2c4c21",
                    color: "white",
                  }}
                  onClick={() => {
                    handleButton("showMore");
                  }}
                >
                  {showMore ? "Ver Menos" : "Ver Mas"}
                </Button>
              </p>
            </div>
            <div className={"feature-3"}>
              <h2 className="font-bold text-xl mb-2 mt-5">
                Responsabilidad ambiental
              </h2>
              <p className="">
                <h6 className={"classResponsive"}>
                  {showMoreClientes ? (
                    <TextConfianzaResponsibo />
                  ) : (
                    textConfianza.substring(0, 150)
                  )}
                </h6>
                <Button
                  variant="contained"
                  style={{
                    marginLeft: "10px",
                    padding: "7px",
                    width: "7rem",
                    height: "2rem",
                    backgroundColor: "#2c4c21",
                    color: "white",
                  }}
                  onClick={() => {
                    handleButton("showMoreClientes");
                  }}
                >
                  {showMoreClientes ? "Ver Menos" : "Ver Mas"}
                </Button>
              </p>
            </div>
          </div>
        }
        {/*  Responsivo ==============*/}

        {/*Destock ==================*/}
        <div className={`hidden sm:flex   mt-3 mb-3 ${clasNameFeature1}`}>
          <div className={clases}>
            {/*  <img src="logo2.jpeg" alt="monitor" /> */}
            <h2 className="font-bold mb-3 color">Divisiónes</h2>
            <p className="">
              <h6 className={classNameSecond}>
                {showMore ? <Services></Services> : text.substring(0, 150)}
              </h6>
            </p>
            <Button
              variant="contained"

              style={{
                backgroundColor: "#2c4c21",
                color: "white",
                marginLeft: "10px",
                padding: "7px",
                width: "7rem",
                height: "2rem",
              }}
              onClick={() => {
                handleButton("showMore");
                scrollToServices();
              }}
            >
              {showMore ? "Ver Menos" : "Ver Mas"}
            </Button>
          </div>
          {/* <div className={clasesFeature2} style={{display: 'none'}}>
            <img src="imgMision_preview_rev_1.jpeg" style={{width: '97px'}} alt="tag" />
            <h2 className="font-bold text-xl mb-2">
            Seguridad en el Trabajo
            </h2>
            <p className="">
              <h6 className={classNameSecond}>
                {showMoreProyects ? (
                  <TextProyect />
                ) : (
                  textProyect.substring(0, 150)
                )}
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    marginLeft: "10px",
                    padding: "7px",
                    width: "7rem",
                    height: "2rem",
                  }}
                  onClick={() => {
                    handleButton("showMoreProyecs");
                    scrollToServices();
                  }}
                >
                  {showMoreProyects ? "Ver Menos" : "Ver Mas"}
                </Button>
              </h6>
            </p>
          </div> */}
          <div className={clasesFeature3}>
            {/* <img
              src="
              logo3.jpeg
"
              alt="fast"
            /> */}
            <h2 className="font-bold mb-3 color">Responsabilidad ambiental</h2>
            <p className="">
              <h6 className={classNameSecond}>
                {showMoreClientes ? (
                  <TextConfianza />
                ) : (
                  textConfianza.substring(0, 150)
                )}
              </h6>
            </p>
            <Button
              variant="contained"
              style={{
                backgroundColor: "#2c4c21",
                color: "white",
                marginLeft: "10px",
                padding: "7px",
                width: "7rem",
                height: "2rem",
              }}
              onClick={() => {
                handleButton("showMoreClientes");
                scrollToServices();
              }}
            >
              {showMoreClientes ? "Ver Menos" : "Ver Mas"}
            </Button>
          </div>
        </div>
        {/* destock */}

        <div className="hidden sm:flex about">

          <div className="">
            <h2 style={{ color: "#2c4c21", fontSize: '3rem', textAlign: 'center', fontWeight: 'bold' }}>Sobre Nosotros</h2>

            <div className="flex justify-between gap-4">
              <div >
                <h1 className="pl-5  text-2xl font-bold" style={{ color: "#f4541c" }}>Visión:</h1>
                <p className="pl-5  ">Incrementar nuestras fronteras de comercialización, ampliando la cobertura geográfica y haciendo más eficiente nuestra gestión.</p>
                <h1 className="pl-5  text-2xl font-bold" style={{ color: "#f4541c" }}>Valores:</h1>
                <p className="pl-5 ">Proveer de plantas de excelente calidad. Para ello, contamos con recursos humanos competentes y capacitados que trabajan con responsabilidad, atentos a las necesidades de nuestros clientes, brindando un producto de calidad.</p>
                <h1 className="pl-5  text-2xl font-bold" style={{ color: "#f4541c" }}>Objetivos:</h1>
                <p className="pl-5 ">Trabajamos con el propósito de que nuestras tecnologías estén en armonía con el medio ambiente y ofrecemos resultados encaminados a aumentar la productividad y la economía. Todo eso basado en la calidad de nuestros productos, cuidando la seguridad y la salud de las personas que se desempeñan en las distintas áreas.</p>
                <h1 className="pl-5  text-2xl font-bold" style={{ color: "#f4541c" }}>Incentivo Local:</h1>
                <p className="pl-5 ">Contribuimos con la sociedad local generando oportunidades laborales, ya que nuestros colaboradores viven en el área cercana a nuestro establecimiento.
                  Tenemos convenios con la Universidad Nacional de Catamarca y el Gobierno de la provincia para capacitar, mediante becas, a estudiantes avanzados o graduados en la Facultad de Ciencias Agrarias. En esta actividad, que es la producción de plantas bajo cubierta y en ambiente controlado de agua, luz y temperatura.</p>
              </div>

              {/* width="640" height="360"  */}
              <div class=" w-full sm:flex sm:pt-10 hidden">
                <video
                  loop
                  controls
                  muted
                  style={{
                    width: "70rem",
                    margin: "auto",
                    height: "30rem",
                    objectFit: "none",
                    cursor: "pointer",
                    border: "5px solid #2c4c21",
                  }}
                >
                  <source src="/videoVivero.mp4" type="video/mp4" />
                </video>

              </div>



            </div>




          </div>

          <div>

          </div>




        </div>







        <div className="sm:hidden aboutResponsive">

          <div className="flex justify-between">

            <div className="">
              <h2
                className={"text-center mb-5 mt-5  text-2xl font-bold"}
                style={{ color: "#2c4c21", fontWeight: 'bold' }}
              >
                Sobre Nosotros
              </h2>

              <h1 className="text-center  text-2xl font-bold" style={{ color: "#f4541c" }}>Visión:</h1>
              <p className="p-2 text-center">Incrementar nuestras fronteras de comercialización, ampliando la cobertura geográfica y haciendo más eficiente nuestra gestión.</p>
              <h1 className=" text-center text-2xl font-bold" style={{ color: "#f4541c" }}>Valores:</h1>
              <p className="p-2 text-center">Proveer de plantas de excelente calidad. Para ello, contamos con recursos humanos competentes y capacitados que trabajan con responsabilidad, atentos a las necesidades de nuestros clientes, brindando un producto de calidad.</p>
              <h1 className=" text-center text-2xl font-bold" style={{ color: "#f4541c" }}>Objetivos:</h1>
              <p className="p-2 text-center">Trabajamos con el propósito de que nuestras tecnologías estén en armonía con el medio ambiente y ofrecemos resultados encaminados a aumentar la productividad y la economía. Todo eso basado en la calidad de nuestros productos, cuidando la seguridad y la salud de las personas que se desempeñan en las distintas áreas.</p>
              <h1 className=" text-center text-2xl font-bold" style={{ color: "#f4541c" }}>Incentivo Local:</h1>
              <p className="p-2 text-center mb-5">Contribuimos con la sociedad local generando oportunidades laborales, ya que nuestros colaboradores viven en el área cercana a nuestro establecimiento.
                Tenemos convenios con la Universidad Nacional de Catamarca y el Gobierno de la provincia para capacitar, mediante becas, a estudiantes avanzados o graduados en la Facultad de Ciencias Agrarias. En esta actividad, que es la producción de plantas bajo cubierta y en ambiente controlado de agua, luz y temperatura.</p>
            </div>




          </div>
        </div>
        {/* <div className="grid-cols-6">
           </div>  */}



        {/* Celular */}

        <div>
          <section className="sm:mb-24 mt-10">
            {/* width="640" height="360"  */}
            <div class="block sm:hidden">
              <video
                loop
                controls
                muted
                style={{
                  width: "40rem",
                  height: "24rem",
                  objectFit: "cover",
                  cursor: "pointer",
                  marginBottom: "20px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              >
                <source src="/videoVivero.mp4" type="video/mp4" />
              </video>
            </div>
          </section>
        </div>




        <footer
          style={{ backgroundColor: "#8c7333  " }}
          className="h-auto w-full text-center pt-10 pb-10"
        >
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            /* style={{ paddingLeft: "56px" }} */
            className="sm:pl-20 pl-0"
          >
            <Grid item xs={12} sm={6}>
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
              >
                <Grid item xs={12} sm={6}>
                  <a
                    href="https://www.google.com/maps/place/Los+Aromos+S.A./@-28.3432448,-65.70834,766m/data=!3m1!1e3!4m6!3m5!1s0x9424248f2e42b379:0x5223a22d1a9fa6!8m2!3d-28.3439365!4d-65.7071244!16s%2Fg%2F11b_02bgt0?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D"
                    className="cursor-pointer" target="_blank"
                  >
                    <img
                      src="UbicacionLosAromos.png"
                      alt="team-working"
                      style={{
                        width: "21rem",
                        height: "13rem",
                        margin: "auto",
                        objectFit: "cover",
                        borderRadius: "4%",
                      }}
                    />
                  </a>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ textAlign: "center", justifyContent: "center" }}
                >
                  <h1
                    className="text-white pt-"
                    style={{ width: "60%", margin: "auto" }}
                  >
                    <LocationOnIcon
                      style={{ color: "white" }}
                      className={"sm:mt-0 mt-4"}
                    />
                    <br></br>
                    Sobre ruta Pcial Nro 41 kilometro 17 del Distrito La Carrera. Dpto FME.
                    <br></br>
                    <br></br>
                    <PhoneIcon
                      style={{ color: "white", marginBottom: "2px" }}
                    />
                    <br></br>
                    Móvil: +54 9 383 4367101
                    <br></br>
                    2do Móvil: +54 9 383 4410824
                    <br></br>
                    <br></br>
                    <EmailIcon style={{ color: "white" }} />{" "}
                    <a>losaromoslacarrera@gmail.com</a>
                    <br></br>
                    <br></br>
                  </h1>
                </Grid>
              </Grid>
            </Grid>
            <div className="mt-96 mb-20 sm:hidden"></div>
            <Grid item xs={12} sm={6} className={"mt-10 sm:mt-0 pl-4 sm:pl-0"}>
              {/*    <nav
                className="text-white mt-28 sm:w-3/6 w-full sm:hidden"
                style={{ margin: "auto" }}
              >
                <a
                  href="https://www.facebook.com/KgoriPunku/?ti=as"
                  className="pr-7"
                >
                  <FacebookIcon style={{ fontSize: "40px" }} />
                </a>
                <a
                  href="https://www.instagram.com/kgori_punku/?hl=es"
                  className="pr-7"
                >
                  <InstagramIcon style={{ fontSize: "40px" }} />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC2U11gD55gFIO9Cwq9lsVZQ/about"
                  className="pr-7"
                >
                  <YouTubeIcon style={{ fontSize: "40px" }} />
                </a>
                <a href="#" onClick={handleWhattsapp} className="pr-7">
                  <WhatsAppIcon
                    style={{ fontSize: "40px", cursor: "pointer" }}
                  />
                </a>
              </nav>
              <nav
                className="text-white mt-28  sm:w-3/6 w-full hidden sm:flex"
                style={{ margin: "auto" }}
              >
                <a
                  href="https://www.facebook.com/KgoriPunku/?ti=as"
                  target={"_blank"}
                  className="pr-7"
                >
                  <FacebookIcon style={{ fontSize: "60px" }} />
                </a>
                <a
                  href="https://www.instagram.com/kgori_punku/?hl=es"
                  target={"_blank"}
                  className="pr-7"
                >
                  <InstagramIcon style={{ fontSize: "60px" }} />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC2U11gD55gFIO9Cwq9lsVZQ/about"
                  target={"_blank"}
                  className="pr-7"
                >
                  <YouTubeIcon style={{ fontSize: "60px" }} />
                </a>
                <a
                  href="#"
                  onClick={handleWhattsapp}
                  target={"_blank"}
                  className="pr-7"
                >
                  <WhatsAppIcon
                    style={{ fontSize: "60px", cursor: "pointer" }}
                  />
                </a>
              </nav> */}
              <h1 className="text-white mt-12 sm:mr-0 mr-8">
                {" "}
                ©Copyrigth 2025 Todos los Derechos Reservados Vivero Los Aromos S.A
              </h1>
            </Grid>
          </Grid>
        </footer>
      </div>
    </body>
  );
}
